export default function userValidators() {
  function multi(validators) {
    for (const result of validators) {
      if (result !== true) {
        return result
      }
    }

    return true
  }

  function email(value) {
    if ( ! value) {
      return true
    }

    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? true
      : 'Tiedon tulee olla sähköpostiosoite'
  }

  function nonEmpty(value) {
    if (value === null || value === undefined) {
      return true
    }

    return value.length
      ? true
      : 'Ei voi olla tyhjä';
  }

  function numeric(value) {
    if (value === null) {
      return true
    }

    return /^\d+$/.test(value)
      ? true
      : 'Tiedon tulee olla numero'
  }

  /*
  function personalNumber(value) {
    if ( ! value) {
      return true
    }

    return /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d+|\d\d-|[01]\dA)\d{3}[\dA-Z]$/.test(value)
      ? true
      : 'Henkilötunnus oltava muotoa 010190-1234. Tarkistathan ettei kenttä sisällä välilyöntejä'
  }
  */

  function personalNumber(value) {
    if ( ! value) {
      return true
    }

    // täytyy olla tasan 11 merkkiä
    if (value.length !== 11) {
      return 'Tarkista henkilötunnuksen muoto, poista välilyönnit'
    }

    const date = value.substring(0, 6)

    // ensimmäiset 6 merkkiä täytyy olla numeroita
    if ( ! /^[0-9]*$/.test(date)) {
      return 'Tarkista henkilötunnuksen päivämäärä'
    }

    const day = Number(value.substring(0, 2))
    const month = Number(value.substring(2, 4))
    const separator = value.substring(6, 7)
    const identifier = value.substring(7, 10)
    const check = value.substring(10, 11)

    // kuukauden täytyy olla 1-12
    if (month < 1 || month > 12) {
      return 'Tarkista henkilötunnuksen kuukausi'
    }

    // päivän täytyy vastata kuukauden päiviä (ei-karkausvuosina helmikuu ei toimi oikein?)
    if (day < 1 || day > [
      31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
    ][month - 1]) {
      return 'Tarkista henkilötunnuksen päivä'
    }

    // erottimen täytyy olla -, + tai A
    if (['-', '+', 'A', 'B', 'C', 'D', 'E', 'F', 'Y', 'X', 'W', 'V', 'U'].indexOf(separator) === -1) {
      return 'Tarkista henkilötunnuksen erotin'
    }

    // merkit 7-10 täytyy olla numeroita
    if ( ! /^[0-9]*$/.test(identifier)) {
      return 'Tarkista henkilötunnuksen yksilöosa'
    }

    // merkki 11 täytyy olla tässä taulukossa paikalla päivämäärän + yksiylöosan jakojäännös
    if (check !== [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'A', 'B', 'C', 'D', 'E', 'F', 'H', 'J', 'K', 'L',
      'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
    ][parseInt(date + identifier) % 31]) {
      return 'Tarkista henkilötunnuksen tarkistemerkki'
    }

    return true
  }

  function postalCode(value) {
    if ( ! value) {
      return true
    }

    return /^\d{5}(?:[-\s]\d{4})?$/.test(value)
      ? true
      : 'Tarkista postinumeron muoto'
  }

  function minLength(min = 2) {
    return function (value) {
      if ( ! value) {
        return true
      }

      return String(value).trim().length >= min
        ? true
        : `Pituus vähintään ${min} merkkiä`
    }
  }

  function required(value) {
    return value !== null && value !== ''
      ? true
      : 'Pakollinen tieto'
  }

  function requiredEmail(value) {
    return multi([required(value), email(value)])
  }

  function requiredNonEmpty(value) {
    return multi([required(value), nonEmpty(value)])
  }

  function requiredNumeric(value) {
    return multi([required(value), numeric(value)])
  }

  function requiredMinLength(min = 2) {
    return function (value) {
      return multi([required(value), minLength(min)(value)])
    }
  }

  function requiredPersonalNumber(value) {
    return multi([required(value), personalNumber(value)])
  }

  function requiredPostalCode(value) {
    return multi([required(value), postalCode(value)])
  }

  function nullable(value) {
    return true
  }

  return {
    email,
    nonEmpty,
    minLength,
    numeric,
    personalNumber,
    postalCode,
    required,
    requiredEmail,
    requiredMinLength,
    requiredNonEmpty,
    requiredNumeric,
    requiredPersonalNumber,
    requiredPostalCode,
    nullable,
  }
}
